import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./AuthContext";

import Home from "./pages/user/Home";
import Login from "./pages/user/Login";
import SearchPage from "./pages/user/SearchPage";
import NewBathroom from "./pages/user/NewBathroom";
import Signup from "./pages/user/Signup";
import Admin from "./pages/admin/Admin";
import UserProfile from "./pages/user/UserProfile";
import Detail from "./pages/user/DetailView";
import AddReview from "./pages/user/AddReview";
import UpdateDetail from "./pages/user/UpdateDetail";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/new-bathroom" element={<NewBathroom />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/admin" element={<Admin />} />
          {<Route path="/user-profile/:data" element={<UserProfile />} />}
          <Route path="/detail/:data" element={<Detail />} />
          <Route path="/add-review/:data" element={<AddReview />} />
          <Route path="/update-detail/:data" element={<UpdateDetail />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
